









































import axios from "axios";
import "material-icons/iconfont/material-icons.css";
import Vue from "vue";

import { VBtn, VCard, VIcon, VMenu, VTooltip } from "vuetify/lib";

export default Vue.extend({
  name: "AlertBtn",
  components: {
    VBtn,
    VCard,
    VIcon,
    VMenu,
    VTooltip
  },

  data() {
    return {
      expand: false,
      Axios: axios.create(),
      allAlerts: [] as any[],
      loadedAlerts: [] as any[][], //any[][]
      loading: false,
      tab: 0,
      auth: undefined,
      roles: [] as any[]
    };
  },
  watch: {
    "auth.authenticated": {
      handler: function() {
        if (this.$vtrs.authenticated) {
          this.setRoles();
          this.setLoadedAlerts();
        }
      }
    }
  },
  async mounted() {
    await this.$nextTick();
    this.$set(this, "auth", this.$vtrs);
  },
  methods: {
    async handleAlertLoad(index: number) {
      if (index === -1) {
        return;
      }
      if (this.loadedAlerts[index].length === 0) await this.loadAlert(index);
    },
    setRoles() {
      if (this.$vtrs == undefined || this.$vtrs.resources == undefined) {
        return;
      }

      try {
        const resources = this.$vtrs.resources;
        Object.keys(resources).forEach(role => {
          const formattedRole = { roleName: role } as any;

          Object.keys(resources[role]).forEach(attr => {
            formattedRole[attr] = resources[role][attr][0];
          });

          this.roles.push(formattedRole);
        });
      } catch (e) {
        return;
      }
    },

    setLoadedAlerts() {
      this.roles
        .filter(role => role.alertURL !== undefined)
        .forEach(() => {
          this.loadedAlerts.push([]);
        });

      this.loadAllAlerts();
    },

    //Allows us to load all alerts and append them to the allAlerts array and then sort the allAlerts array.
    loadAllAlerts() {
      const alertPromises: Promise<void>[] = [];

      this.loadedAlerts.forEach((__x, index) => {
        alertPromises[index] = this.loadAlert(index);
      });

      Promise.all(alertPromises).then(() => {
        let alerts: any[] = [];

        this.loadedAlerts.forEach(alertArr => {
          alerts = alerts.concat(alertArr);
        });

        alerts.sort((a, b) => {
          return (
            new Date(b.activateOn).getTime() - new Date(a.activateOn).getTime()
          );
        });

        this.allAlerts = alerts;
      });
    },

    async loadAlert(index: number) {
      try {
        this.loading = true;
        this.loadedAlerts[index] = ((
          await this.Axios.get(
            this.roles.filter(role => role.alertURL !== undefined)[index]
              .alertURL
          )
        ).data as any[]).sort((a, b) => {
          return (
            new Date(b.activateOn).getTime() - new Date(a.activateOn).getTime()
          );
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    getSeverityColor(severityLevel: number): string {
      let severityColor = "green";

      switch (severityLevel) {
        case 1:
          severityColor = "#FFD700";
          break;
        case 2:
          severityColor = "orange";
          break;
        case 3:
          severityColor = "red";
          break;
      }

      return severityColor;
    },
    getSeverityName(severityLevel: number): string {
      let severity = "Low";

      switch (severityLevel) {
        case 1:
          severity = "Medium";
          break;
        case 2:
          severity = "High";
          break;
        case 3:
          severity = "Critical";
          break;
      }

      return severity;
    }
  }
});
